export enum DiaryFormFrequencyType {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
  EveryXDays = 3,
  EveryXWeeks = 4
}
